<template>
  <div>
    <header-image
    :headerContents="headerContents"
    :headerBackground="'home'"
    />
    <div class="grid-container full">
      <div class="grid-x programemsCarousel page-contents-8">
        <div class=" small-12 cell">
          <h1>PRIVACY POLICY</h1>

          <hr/>

          <p class="modal"><b>NON-EU APPLICANTS</b></p>

          <p class="modal">If you come from outside the European Union, you are eligible to apply for student finance from Student Finance England to cover your university tuition fees and living costs, provided that you meet all of the following conditions:</p>

          <ul class="modal">
            <li>You are a UK national, or have ‘settled status’ – this includes permanent or indefinite leave to remain (i.e. no restrictions on how long you can stay)</li>
            <li>You normally live in England</li>
            <li>You have been living in the UK, the Channel Islands or the Isle of Man for 3 years before starting your university course</li>
          </ul>

          <p class="modal">You may also be eligible if you meet one of the following conditions:</p>

          <ul class="modal">
            <li>You are a refugee</li>
            <li>You are stateless</li>
            <li>You are under humanitarian protection</li>
          </ul>

          <p class="modal">These immigration statuses are determined by the Home Office. We recommend that you check your immigration status before applying to university. For more information on student finance, please go to <a href="https://www.gov.uk/student-finance/who-qualifies" target="_blank">https://www.gov.uk/student-finance/who-qualifies</a></p>

          <p class="modal">Rare cannot help you qualify for these statuses.</p>

          <p class="modal">If you are not eligible, you may be liable to pay the higher international tuition fees and find alternative ways to cover your living costs.</p>

          <p>&nbsp;</p><p>&nbsp;</p>

        </div>
      </div>
    </div>

    <want-to-know-more/>
    <rare-awards/>
  </div>
</template>

<script>
import HeaderHeroImage from '../../components/header/HeaderHeroImage';
import RareWantToKnowMore from '../../components/commonSections/RareWantToKnowMore';
import RareAwards from '../../components/carousels/awardsCarousel';
import RareHomeHeaderContents from './components/RareHomeHeaderContents';

export default {
  name: 'home',
  components: {
    'header-image': HeaderHeroImage,
    'want-to-know-more': RareWantToKnowMore,
    'rare-home-header-contents': RareHomeHeaderContents,
    'rare-awards': RareAwards,
  },
  data() {
    return {
      headerContents: 'rare-home-header-contents',
    };
  },
  mounted() {
  },
};

</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .modal-mask {
    position: fixed;
    z-index: 9990;
    top: 0;
    left: 0;
    width: 100%;
    height: 200%;
    display: table;
    transition: opacity .3s ease;
    background-color: rgba(255,255,255, .95);
    overflow: scroll;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    opacity: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9991;
  }

  .modal-container {
    width: 100%;
    margin: 0px auto;
    padding: 0;
    background-color: transparent;
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    opacity: 1;
  }


  .modal-body {
    margin: 0;
  }

  .modal-default-button {
    float: right;
  }

  /* NAVIGATION TEXT STYLES FOR BOTH SIZES */

  hr {
    margin: 0 auto 36px 0 !important;
    border-bottom: 1px solid #c4cace;
  }

  h1 {
    color: $main-text;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  }

  p, h2, h3 {
    color: $main-text;
  }


  @media only screen and (max-width: 640px)  {


    .rareModalCloseIcon {
      cursor: pointer;
      position: absolute;
      right: 8px;
      top: 22px;
      z-index: 9995;
    }

    h1 {
      font-size: 24px;
      line-height: 1.33;
      letter-spacing: 3px;
      margin: 80px 0 16px 0;
    }

  }

  @media only screen and (min-width: 641px)  {
    .rareModalCloseIcon {
      cursor: pointer;
      position: absolute;
      right: 124px;
      top: 84px;
      z-index: 9995;
    }

    h1 {
      font-size: 48px;
      line-height: 0.83;
      letter-spacing: 8px;
      margin: 88px 0 47px 0;
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/nonEU/nonEU.vue